/*
  Shreya — <best-selling-showcase>
  "Explore" grows the product panel over the lifestyle image (desktop);
  the close button or Esc folds it back.
*/
(() => {
  if (customElements.get('best-selling-showcase')) return;

  const FADE_MS = 380;

  class BestSellingShowcase extends HTMLElement {
    connectedCallback() {
      this.exploreBtn = this.querySelector('[data-explore]');
      this.collapseBtn = this.querySelector('[data-collapse]');
      if (this.exploreBtn) this.exploreBtn.addEventListener('click', () => this.expand());
      if (this.collapseBtn) this.collapseBtn.addEventListener('click', () => this.collapse());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-expanded')) this.collapse();
      });
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    expand() {
      if (this.classList.contains('is-expanded')) return;
      // first fade the copy on the image, then slide the panel across
      this.classList.add('is-leaving');
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.classList.add('is-expanded');
        if (this.exploreBtn) this.exploreBtn.setAttribute('aria-expanded', 'true');
        if (this.collapseBtn) this.collapseBtn.focus({ preventScroll: true });
      }, FADE_MS);
    }

    collapse() {
      this.classList.remove('is-expanded');
      if (this.exploreBtn) this.exploreBtn.setAttribute('aria-expanded', 'false');
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.classList.remove('is-leaving');
        if (this.exploreBtn) this.exploreBtn.focus({ preventScroll: true });
      }, FADE_MS + 300);
      const track = this.querySelector('[data-slider-track]');
      if (track) track.scrollTo({ left: 0 });
    }
  }

  customElements.define('best-selling-showcase', BestSellingShowcase);
})();
